import { Form, Select, Input } from 'antd';
import type { FormInstance } from 'antd/es/form';
import { useEffect, useState } from 'react';

interface MesuraFieldProps {
  form: FormInstance;
  editar?: boolean;
}

const MesuraField: React.FC<MesuraFieldProps> = ({ form, editar = true }) => {
  const [isAltres, setIsAltres] = useState(false);

  useEffect(() => {
    if (!isAltres) {
      form.setFieldsValue({ mesuraCustom: undefined });
    }
  }, [isAltres]);

  const handleSelectChange = (value: string) => {
    if (value === 'Altres') {
      setIsAltres(true);
    } else {
      setIsAltres(false);
      form.setFieldsValue({ mesura: value });
    }
  };

  const handleCustomChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const customValue = e.target.value;
  form.setFieldsValue({ mesura: customValue });
};

  return (
    <>
      <Form.Item
        label="Mesura"
        name="mesura"
        rules={[{ required: true, message: 'Aquest camp és obligatori' }]}
      >
        <Select
          placeholder="Selecciona una mesura"
          onChange={handleSelectChange}
          disabled={!editar}
        >
          {[
            'kg', 'g', 'l', 'ml', 'u', 'pack','caixa',
            'unitat', 'ml/s', 'g/m2', 'L/m2', 'Altres'
          ].map((unit) => (
            <Select.Option key={unit} value={unit}>
              {unit}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      {isAltres && (
        <Form.Item
          name="mesuraCustom"
          label="Escriu la mesura"
          rules={[{ required: true, message: 'Escriu una mesura:' }]}
        >
          <Input onChange={handleCustomChange} disabled={!editar} />
        </Form.Item>
      )}
    </>
  );
};

export default MesuraField;
